<template>
    <send-list-form
        v-bind="formData"
        :mode="mode"
        @created="onCreated"
        @updated="onUpdated"
    ></send-list-form>
</template>

<script>
  import Form from "../send-list/form";

  export default {
    components: {
      'send-list-form': Form,
    },

    props: {
      getFormUrl: String,
      initialModel: Object,
      mode: null,
    },

    data() {
      return {
        formData: null,
      };
    },

    methods: {
      loadForm() {
        axios.get(this.getFormUrl)
          .then(({data: {data: {model, ...properties}}}) => {
            this.formData = properties;
            this.formData.initialModel = _.assign(model, this.initialModel);
            this.$emit('initialized');
          })
          .catch(({response: {data: {message}}}) => {
            const payload = _.assign({}, message ? {message} : {});
            this.$emit('initialization-error', payload);
          });
      },

      onCreated(payload) {
        this.$emit('created', payload);
      },

      onUpdated(payload) {
        this.$emit('updated', payload);
      },
    },

    mounted() {
      this.loadForm();
    },
  }
</script>

